export function setAuditLogsPaginated(state, payload) {
  if (state.auditLogsPaginated.totalDocs == null) {
    state.auditLogsPaginated = payload;
  } else {
    state.auditLogsPaginated.docs = payload.docs;
    state.auditLogsPaginated.totalDocs = payload.totalDocs;
    state.auditLogsPaginated.limit = payload.limit;
    state.auditLogsPaginated.totalPages = payload.totalPages;
    state.auditLogsPaginated.page = payload.page;
    state.auditLogsPaginated.pagingCounter = payload.pagingCounter;
    state.auditLogsPaginated.hasPrevPage = payload.hasPrevPage;
    state.auditLogsPaginated.hasNextPage = payload.hasNextPage;
    state.auditLogsPaginated.prevPage = payload.prevPage;
    state.auditLogsPaginated.nextPage = payload.nextPage;
  }
}

export function setAuditStats(state, stats) {
  state.auditStats = stats;
}

export function setAuditLogDetail(state, log) {
  state.auditLogDetail = log;
}

export function clearAuditLogs(state) {
  state.auditLogsPaginated = {
    docs: [],
    totalDocs: null,
    limit: 20,
    totalPages: null,
    page: 1,
    pagingCounter: null,
    hasPrevPage: false,
    hasNextPage: true,
    prevPage: null,
    nextPage: null
  };
  state.auditStats = null;
}
